import { ColumnDef } from '@tanstack/react-table'
import { Area } from '@/interfaces/area'
import { SelectInterface } from '@/interfaces/InterfacesLocal'
import StateSpanForTable from '@/components/misc/badges/StateSpanForTable'

const areaTypes: SelectInterface[] = [
  { id: 'STOCK', name: 'Almacén' },
  { id: 'MANUFACTURER', name: 'Área de procesado' },
  { id: 'SALE', name: 'Punto de venta' },
  { id: 'ACCESSPOINT', name: 'Punto de acceso' },
]

export const columns: ColumnDef<Area>[] = [
  {
    accessorKey: 'name',
    header: 'Área',
    cell: ({ row }) => {
      return (
        <div className="items-center py-3">
          <span>{row.original.name}</span>
        </div>
      )
    },
    enableHiding: false, // Important column, don't allow hiding
  },
  {
    accessorKey: 'type',
    header: 'Tipo',
    cell: ({ row }) => {
      return (
        <div className="items-center py-3">
          <span>
            {areaTypes.find((item) => item.id === row.original.type)?.name}
          </span>
        </div>
      )
    },
    enableHiding: false, // Important column, don't allow hiding
  },
  {
    accessorKey: 'isActive',
    header: 'Estado',
    cell: ({ row }) => {
      return (
        <div className="items-center py-3">
          <StateSpanForTable
            currentState={row.original.isActive}
            greenState="Activa"
            redState="Inactiva"
          />
        </div>
      )
    },
    enableHiding: false, // Important column, don't allow hiding
  },
]
